import React from 'react';

import { useLocale } from '@adsk/alloy-react-locale';

import ReferencePickerPlugin from '../../../../types/ReferencePickerPlugin';
import { SubmittalsItem } from '../../types';

const RemoveReferenceModalContent: ReferencePickerPlugin<SubmittalsItem>['CustomRemoveEntityModalContent'] =
  () => {
    const { T } = useLocale(({ locale }) =>
      require(`../../i18n/${locale}.json`),
    );

    return <span>{T.translate('REMOVE_REFERENCE_CONFIRMATION_TEXT')}</span>;
  };

export default RemoveReferenceModalContent;
